module.exports = __webpack_public_path__ + "img/ca1.e3e42505.jpeg";